// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"babe4c90","977":"bec52d80"}[chunkId] + ".chunk.js";
};